<template>
  <div class="common-home-content" :class="show_index == 0?'common-home-content-pb':''" v-show="show">
    <van-search 
      class="search-input" 
      v-model="keyword" 
      placeholder="输入方名、首字母、类别"
      @input="onInput"
      @search="onSearch"
      @clear="onClear"
    />
    <ul class="tab-ul clearfix">
      <li class="fl" :class="show_index == 0?'actived':''" @click="handleShow(0)"><span>药方模板</span></li>
      <li class="fr" :class="show_index == 1?'actived':''" @click="handleShow(1)"><span>经典方</span></li>
    </ul>
    <div class="common-scroll" v-if="show_index == 0">
      <van-list
        v-model="self_loading"
        :finished="self_finished"
        @load="getSelfDate(false)"
        v-if="selfprescriptions.length > 0"
      >
        <ul class="prescriptions-ul space_pl space_pr">
          <li
            v-for="(child, index) in selfprescriptions"
            :key="index"
            @click="handleSelect(child)"
          >
            <p class="name">{{child.name}}</p>
            <p class="content">{{getContentDate(child.content)}}</p>
          </li>
        </ul>
        <p class="no-more" v-if="self_total_pages > 1 && self_finished">没有更多了</p>
      </van-list>
      <div class="not-prescriptions" v-else>
        <img src="../../assets/images/address/tip.png" alt="">
        <p class="title" v-if="keyword">抱歉，暂时没有搜索到您想要的~</p>
        <p class="title" v-else>您还没有药方模板哦~</p>
      </div>
      <div class="fixed-button">
        <button @click="toEditPrescription">设置常用方</button>
      </div>
    </div>
    <div class="common-scroll" v-if="show_index == 1">
      <p class="categories-title space_pl">经典方类别</p>
      <ul class="categories-ul clearfix">
        <li
          class="fl"
          :class="child.category_id == category_id?'actived':''"
          v-for="(child, index) in categories"
          :key="index"
        >
          <div @click="handleChangeCategory(child.category_id)">
            <p class="name">{{child.name}}</p>
          </div>
        </li>
      </ul>
      <van-list
        v-model="system_loading"
        :finished="system_finished"
        @load="getSystemDate(false)"
        v-if="systemprescriptions.length > 0"
      >
        <ul class="prescriptions-ul space_pl space_pr">
          <li
            v-for="(child, index) in systemprescriptions"
            :key="index"
            @click="handleSelect(child)"
          >
            <p class="name">{{child.name}}</p>
            <p class="content">{{getContentDate(child.content)}}</p>
          </li>
        </ul>
        <p class="no-more" v-if="system_total_pages > 1 && system_finished">没有更多了</p>
      </van-list>
      <div class="not-prescriptions not-prescriptions2" v-else>
        <img src="../../assets/images/address/tip.png" alt="">
        <p class="title" v-if="keyword">抱歉，暂时没有搜索到您想要的~</p>
        <p class="title" v-else>您还没有经典方哦~</p>
      </div>
    </div>
  </div>
</template>
<script>
import {_} from 'vue-underscore';
import $ from 'jquery'
import http from '../../util/dorisApiConfig'
export default {
  data() {
    return {
      show: false,
      show_index: 0,
      self_loading: false,
      self_finished: false,
      systemp_loading: false,
      systemp_finished: false,
      token: '',
      doctor_id: 1,
      keyword: '',
      self_current_page: 0,
      self_total_pages: 1,
      systemp_current_page: 0,
      systemp_total_pages: 1,
      page_size: 10,
      categories: [],
      category_id: 1,
      selfprescriptions: [],
      systemprescriptions: []
    };
  },
  created() {
    this.$appUtils.showAppTrBtn({});
    var user_info = this.$appUtils.appData();
    if(user_info){
        this.doctor_id = user_info.doctor_id;
        this.token = user_info.token;
    }
    let that = this;
    http.get("/drugs/categories", {
      headers: {
          "Authorization": that.token
      }
    }).then(function(res) {
        if(res.data.status_code == 200){
          that.categories = res.data.data;
        }
    });
    this.getSelfDate(true);
    this.getSystemDate(true);
    window.appBack = ()=> this.pageback();
  },
  methods: {
    companyFormat(str){
      if(str == "克"){
        return "g";
      }else{
        return str;
      }
    },
    getContentDate(json){
      let that = this;
      let str = "";
      if(json){
        if(typeof(json) == 'string'){
          json = JSON.parse(json);
        }
        for(let i = 0; i < json.length; i++){
          if(i == 0){
            if(json[i]['usage']){
              str = json[i]['name'] + '('+json[i]['usage']+')' + ' ' + json[i]['quantity'] + that.companyFormat(json[i]['unit']);
            }else{
              str = json[i]['name'] + ' ' + json[i]['quantity'] + that.companyFormat(json[i]['unit']);
            }
            
          }else{
            if(json[i]['usage']){
              str += '，' + json[i]['name'] + '('+json[i]['usage']+')' + ' ' + json[i]['quantity'] + that.companyFormat(json[i]['unit']);
            }else{
              str += '，' + json[i]['name'] + ' ' + json[i]['quantity'] + that.companyFormat(json[i]['unit']);
            }
          }
        }
      }
      return str;
    },
    getSelfDate(clear) {
      let that = this;
      if(clear){
        that.self_current_page = 0;
      }
      let params = {
          page: that.self_current_page + 1,
          page_size: that.page_size
      }
      if(that.keyword){
        params['keyword'] = that.keyword;
      }
      that.self_loading = true;
      http.get("/drugs/"+that.doctor_id+"/self_prescriptions", {params: params,
        headers: {
            "Authorization": that.token
        }
      }).then(function(res) {
          if(res.data.status_code == 200){
            if(clear){
              that.selfprescriptions = [];
            }
            that.selfprescriptions = that.selfprescriptions.concat(res.data.data.prescriptions);
            that.self_current_page = parseInt(res.data.data.current_page);
            that.self_total_pages = parseInt(res.data.data.total_pages);
            if(that.self_current_page >= that.self_total_pages){
              that.self_finished = true;
            }else{
              that.self_finished = false;
            }
          }
          that.self_loading = false;
          that.show = true;
          that.$forceUpdate();
          that.$appUtils.appCloseLoadingView();
      });
    },
    getSystemDate(clear) {
      let that = this;
      if(clear){
        that.system_current_page = 0;
      }
      let params = {
          page: that.system_current_page + 1,
          page_size: that.page_size
      }
      if(that.keyword){
        params['keyword'] = that.keyword;
      }
      params['category_id'] = that.category_id;
      that.system_loading = true;
      http.get("/drugs/"+that.doctor_id+"/common_prescriptions", {params: params,
        headers: {
            "Authorization": that.token
        }
      }).then(function(res) {
          if(res.data.status_code == 200){
            if(clear){
              that.systemprescriptions = [];
            }
            that.systemprescriptions = that.systemprescriptions.concat(res.data.data.prescriptions);
            that.system_current_page = parseInt(res.data.data.current_page);
            that.system_total_pages = parseInt(res.data.data.total_pages);
            if(that.system_current_page >= that.system_total_pages){
              that.system_finished = true;
            }else{
              that.system_finished = false;
            }
          }
          that.system_loading = false;
          that.$forceUpdate();
      });
    },
    throttleFun:_.throttle(function(){
      this.self_finished = false;
      this.systemp_finished = false;
      this.getSelfDate(true);
      this.getSystemDate(true);
    }, 200, {leading: false}),
    onInput(){
      this.throttleFun();
    },
    onSearch() {
      this.self_finished = false;
      this.systemp_finished = false;
      this.getSelfDate(true);
      this.getSystemDate(true);
    },
    onClear() {
      
    },
    handleSelect(item){
      if(typeof(item["content"]) == 'string'){
        item["content"] = JSON.parse(item["content"])
      }
      this.$appUtils.appSelectPrescription(item);
    },
    handleChangeCategory(id){
      this.category_id = id;
      this.systemp_finished = false;
      this.getSystemDate(true);
    },
    handleShow(index){
      if(this.show_index != index){
        this.show_index = index;
        $(".common-scroll").scrollTop(0);
      }
    },
    toEditPrescription(){
      this.$router.push({ path: "/mangeprescriptions?t=1"});
    },
    pageback(){
      return null;
    }  
  },
};
</script>
<style lang="scss" scoped>
.common-home-content{
  height: 100%;
  padding-top: 92px;
  box-sizing: border-box;
  overflow: hidden;
}
.common-home-content-pb{
  padding-bottom: 52px;
}
.common-scroll{
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding-bottom: 10px;
}
.search-input{
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #333333;
  position: fixed;
  top:0;
  left: 0;
  .van-search__content{
    padding-left: 0;
    background: #F4F4F4;
    border-radius: 17px;
    .van-field{
      border: 0;
      box-shadow: none;
    }
  }
}
.tab-ul{
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  top:36px;
  left: 0;
  & > li{
    width: 50%;
    line-height: 56px;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    text-align: center;
    position: relative;
    z-index: 10;
  }
  span{
    position: relative;
    z-index: 10;
  }
  .actived{
    color: #AC4B38;
    font-family: PingFang-SC-Bold;
    font-weight: Bold;
  }
  .actived::before{
    content: '';
    display: block;
    box-sizing: border-box;
    width: 16px;
    height: 14px;
    border: 2px solid #AC4B38;
    border-radius: 16px;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 9px;
  }
  .actived::after{
    content: '';
    display: block;
    box-sizing: border-box;
    width: 16px;
    height: 7px;
    background-color: #ffffff;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 16px;
  }
}
.prescriptions-ul{
  margin-top: 10px;
  width: 100%;
  box-sizing: border-box;
  & > li{
    margin-bottom: 10px;
    width: 100%;
    padding: 20px 10px 17px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
    border-radius: 10px;
    .name{
      line-height: 24px;
      font-size: 16px;
      font-family:  PingFang-SC-Medium;
      font-weight: 500;
      color: #AC4B38;
      padding-right: 50px;
      position: relative;
    }
    .content{
      margin-top: 10px;
      line-height: 20px;
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #666666;
    }
  }
}
.categories-title{
  margin-top: 14px;
  line-height: 14px;
  font-size: 14px;
  font-family: PingFang-SC-Bold;
  font-weight: bold;
  color: #333333;
}
.categories-ul{
  margin-top: 15px;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  & > li{
    width: 25%;
    box-sizing: border-box;
    padding: 0 5px;
    margin-bottom: 10px;
    & > div{
      width: 100%;
      box-sizing: border-box;
      line-height: 34px;
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #333333;
      text-align: center;
      border: 1px solid #e6e6e6;
      border-radius: 18px;
    }
  }
  .actived{
    & > div{
      color: #ffffff;
      border: 1px solid #AC4B38;
      background-color: #AC4B38;
    }
  }
}
.no-more{
  color: #969799;
  font-size: 14px;
  line-height: 50px;
  text-align: center;
}
.not-prescriptions{
  margin-top: 182px;
  width: 100%;
  display: inline-block;
  text-align: center;
  img{
    width: 118px;
  }
  .title{
    margin-top: 17px;
    line-height: 16px;
    font-size:16px;
    font-family: PingFang-SC-Medium;
    font-weight:500;
    color:rgba(154,154,154,1);
  }
}
.not-prescriptions2{
  margin-top: 30px;
}
.fixed-button{
  width: 100%;
  box-sizing: border-box;
  padding: 3px 15px;
  position:fixed;
  left: 0;
  bottom: 0;
  & > button{
    display: block;
    width: 100%;
    box-sizing: border-box;
    line-height: 43px;
    font-size:17px;
    font-family: PingFang-SC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: center;
    background:rgba(172,76,56,1);
    border-radius:4px;
  }
}
.van-popup{
  border-radius: 6px;
}
</style>
<style>
.search-input .van-field__left-icon{
    margin-left: 13px;
    margin-right: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/doctor/selectprescription.vue